<div class="header-container" data-cy="header-container">
  <div class="header-layout" [ngStyle]="{ 'padding-top.px': nativeSafeZoneService.paddings.top }">
    <svg-icon (click)="openMobileMenu()" class="mobile-menu-burger" src="assets/icons/burger.svg" [svgStyle]="{ 'width.px':24 }" data-cy="mobile-menu-burger"></svg-icon>

    <a class="logo-container" routerLink="/summary">
      <svg-icon class="mobile" src="assets/logo/logo.svg" [svgStyle]="{ 'width.px':220 }"></svg-icon>
      <svg-icon class="desktop" src="assets/logo/logo-big.svg" [svgStyle]="{ 'width.px':290 }"></svg-icon>
    </a>

    <div class="desktop-menu-container">
      <nav class="desktop-menu">
        <ul>
          <li>
            <a class="desktop-menu-item" data-cy="desktop-menu-item" routerLink="/summary"
              [ngClass]="{'desktop-menu-item--active': isSummary &&!consultationLinkActive &&  !investmentsLinkActive}">
              {{ 'menu.summary' | translate }}
            </a>
          </li>
          <li>
            <a class="desktop-menu-item" data-cy="desktop-menu-item" routerLink="/summary"
              [ngClass]="{'desktop-menu-item--active': investmentsLinkActive && !consultationLinkActive}"
              (click)="onInvestmentsLinkClicked()">
              {{ 'menu.investments' | translate }}
            </a>
          </li>
          <li>
            <div
              class="desktop-menu-item" (click)="openModal()"
              (keydown.space)="openModal()"
              (keydown.enter)="openModal()"
              tabindex="0"
              [ngClass]="{'desktop-menu-item--active': consultationLinkActive}"
              data-cy="desktop-menu-consultation-btn desktop-menu-item"
            >
              {{ 'menu.consultation' | translate }}
            </div>
          </li>
          <li>
            <a data-cy="desktop-money-menu-link desktop-menu-item desktop-menu-transactions-btn" class="desktop-menu-item" routerLink="/money"
              [ngClass]="{'desktop-menu-item--active': !consultationLinkActive && isMoney}">
              {{ 'menu.moneyAndTransactions' | translate }}
            </a>
          </li>
          <li>
            <div data-cy="desktop-blog-top-menu-link desktop-menu-item" class="desktop-menu-item" routerLink="/blog"
              [ngClass]="{'desktop-menu-item--active': !consultationLinkActive && isBlog}">
              {{ 'menu.blog' | translate }}
            </div>
          </li>
        </ul>
      </nav>
    </div>

    <div class="icons-container">
      <div class="mobile-icons">
        <div class="notification-icon-container" routerLink="/notifications" data-cy="notifications-mobile-bell">
          @if (userNotificationService.unreadNotificationsCount > 0) {
            <div class="unread-notifications">
              {{ userNotificationService.unreadNotificationsCount }}
            </div>
          }
          <svg-icon src="assets/icons/bell.svg" [svgStyle]="{ 'width.px':25 }"></svg-icon>
        </div>
      </div>

      <div class="desktop-icons">
        <div class="notification-icon-container" routerLink="/notifications" data-cy="notifications-desktop-bell">
          @if (userNotificationService.unreadNotificationsCount > 0) {
            <div class="unread-notifications">
              {{ userNotificationService.unreadNotificationsCount }}
            </div>
          }
          <svg-icon src="assets/icons/bell.svg" [svgStyle]="{ 'width.px':21 }"></svg-icon>
        </div>
        <div
          class="user-icon"
          (click)="toggleDesktopSmallMenu($event)"
          data-cy="desktop-header-menu-user-icon"
          (keydown.space)="toggleDesktopSmallMenu($event)"
          (keydown.enter)="toggleDesktopSmallMenu($event)"
          tabindex="0"
        >
          <svg-icon src="assets/icons/user.svg" [svgStyle]="{ 'width.px':21 }"></svg-icon>

          <div
            class="small-menu-container "
            [ngClass]="{ 'small-menu-container--toggled': !!desktopSmallMenuToggled }"
            data-cy="desktop-small-user-menu"
            id="{{ desktopMenuElementId }}"
          >
            <div class="small-menu-item" routerLink="/user" data-cy="desktop-header-menu-profile">
              <svg-icon src="assets/icons/user.svg" [svgStyle]="{ 'width.px':21 }"></svg-icon>
              <div class="small-menu-item-text">
                {{ 'menu.myProfile' | translate }}
              </div>
            </div>
            <div class="small-menu-item" routerLink="/documents" data-cy="desktop-documents-menu-link">
              <svg-icon src="assets/icons/document.svg" [svgStyle]="{ 'width.px':21 }"></svg-icon>
              <div class="small-menu-item-text">
                {{ 'menu.dokuments' | translate }}
              </div>
            </div>
            <div class="small-menu-item" routerLink="/videos" data-cy="desktop-videos-menu-link">
              <svg-icon src="assets/icons/video.svg" [svgStyle]="{ 'width.px':21 }"></svg-icon>
              <div class="small-menu-item-text">
                {{ 'menu.videos' | translate }}
              </div>
            </div>

            <div
              class="logout-button-container"
              (click)="logOut()"
              (keydown.space)="logOut()"
              (keydown.enter)="logOut()"
              tabindex="0"
            >
              <libero-button
                label="{{ 'menu.logout' | translate }}"
                btnClasses="btn--secondary btn--small"
                data-cy="logout-btn"
              ></libero-button>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>

  @if (mobileMenuVisible) {
    <div class="mobile-menu-container" [ngStyle]="{ 'margin-top.px': nativeSafeZoneService.paddings.top }">
      <div class="mobile-menu-container-logo">
        <svg-icon src="assets/logo/logo.svg" [svgStyle]="{ 'width.px':152 }"></svg-icon>
      </div>
      <div
        class="mobile-menu-close-button"
        (click)="closeMobileMenu()"
        (keydown.space)="closeMobileMenu()"
        (keydown.enter)="closeMobileMenu()"
        tabindex="0"
      >
        <svg-icon src="assets/icons/cross.svg" [svgStyle]="{ 'width.px':15 }"></svg-icon>
      </div>
      <div class="row g-0 mobile-menu-actions">
        <hr class="divider">
        <div
          class="col-12 mobile-menu-item"
          (click)="closeMenuAndNavigate('/summary')"
          (keydown.space)="closeMenuAndNavigate('/summary')"
          (keydown.enter)="closeMenuAndNavigate('/summary')"
          tabindex="0"
        >
          <div class="mobile-menu-icon">
            <svg-icon src="assets/icons/chart-up.svg" [svgStyle]="{ 'width.px':26 }"></svg-icon>
          </div>
          <div class="mobile-menu-label">
            {{ 'menu.summary' | translate }}
          </div>
        </div>
        <hr class="divider">
        <div
          class="col-12 mobile-menu-item"
          (click)="closeMenuAndNavigate('/summary', true)"
          data-cy="header-mobile-menu-link-investments"
          (keydown.space)="closeMenuAndNavigate('/summary', true)"
          (keydown.enter)="closeMenuAndNavigate('/summary', true)"
          tabindex="0"
        >
          <div class="mobile-menu-icon">
            <svg-icon src="assets/icons/bar-chart.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
          </div>
          <div class="mobile-menu-label">
            {{ 'menu.investments' | translate }}
          </div>
        </div>
        <hr class="divider">
        <div
          class="col-12 mobile-menu-item"
          (click)="closeMenuAndNavigate('/money')"
          data-cy="header-mobile-menu-link-transactions"
          (keydown.space)="closeMenuAndNavigate('/money')"
          (keydown.enter)="closeMenuAndNavigate('/money')"
          tabindex="0"
        >
          <div class="mobile-menu-icon">
            <svg-icon src="assets/icons/wallet.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
          </div>
          <div class="mobile-menu-label">
            {{ 'menu.moneyAndTransactions' | translate }}
          </div>
        </div>
        <hr class="divider">
        <div
          class="col-12 mobile-menu-item"
          (click)="closeMenuAndNavigate('/notifications')"
          data-cy="notifications-mobile-menu-bell"
          (keydown.space)="closeMenuAndNavigate('/notifications')"
          (keydown.enter)="closeMenuAndNavigate('/notifications')"
          tabindex="0"
        >
          <div class="mobile-menu-icon">
            <svg-icon src="assets/icons/bell.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
          </div>
          <div class="mobile-menu-label">
            {{ 'menu.notifications' | translate }}
          </div>
          @if (userNotificationService.unreadNotificationsCount > 0) {
            <div class="unread-notifications unread-notifications--menu-item">
              {{ userNotificationService.unreadNotificationsCount }}
            </div>
          }
        </div>
        <hr class="divider">
        <div
          class="col-12 mobile-menu-item"
          (click)="closeMenuAndNavigate('/documents')"
          data-cy="header-mobile-menu-link-documents"
          (keydown.space)="closeMenuAndNavigate('/documents')"
          (keydown.enter)="closeMenuAndNavigate('/documents')"
          tabindex="0"
        >
          <div class="mobile-menu-icon">
            <svg-icon src="assets/icons/document.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
          </div>
          <div class="mobile-menu-label">
            {{ 'menu.dokuments' | translate }}
          </div>
        </div>
        <hr class="divider">
        <div
          class="col-12 mobile-menu-item"
          (click)="closeMenuAndNavigate('/blog')"
          data-cy="header-mobile-menu-link-blog"
          (keydown.space)="closeMenuAndNavigate('/blog')"
          (keydown.enter)="closeMenuAndNavigate('/blog')"
          tabindex="0"
        >
          <div class="mobile-menu-icon">
            <svg-icon src="assets/icons/pencil.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
          </div>
          <div class="mobile-menu-label">
            {{ 'menu.blog' | translate }}
          </div>
        </div>
        <hr class="divider">
        <div
          class="col-12 mobile-menu-item"
          (click)="closeMenuAndNavigate('/videos')"
          (keydown.space)="closeMenuAndNavigate('/videos')"
          (keydown.enter)="closeMenuAndNavigate('/videos')"
          tabindex="0"
        >
          <div class="mobile-menu-icon">
            <svg-icon src="assets/icons/video.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
          </div>
          <div class="mobile-menu-label">
            {{ 'menu.videos' | translate }}
          </div>
        </div>
        <hr class="divider">
        <div
          class="col-12 mobile-menu-item"
          (click)="closeMenuAndNavigate('consultation')"
          (keydown.space)="closeMenuAndNavigate('consultation')"
          (keydown.enter)="closeMenuAndNavigate('consultation')"
          tabindex="0"
        >
          <div class="mobile-menu-icon">
            <svg-icon src="assets/icons/accountant.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
          </div>
          <div class="mobile-menu-label">
            {{ 'menu.consultation' | translate }}
          </div>
        </div>
        <hr class="divider">
        <div
          class="col-12 mobile-menu-item"
          (click)="closeMenuAndNavigate('/user')"
          data-cy="header-mobile-menu-profile"
          (keydown.space)="closeMenuAndNavigate('/user')"
          (keydown.enter)="closeMenuAndNavigate('/user')"
          tabindex="0"
        >
          <div class="mobile-menu-icon">
            <svg-icon src="assets/icons/user.svg" [svgStyle]="{ 'width.px':28 }"></svg-icon>
          </div>
          <div class="mobile-menu-label">
            {{ 'menu.myProfile' | translate }}
          </div>
        </div>
        <hr class="divider">
      </div>
      <div
        class="mobile-menu-logout"
        (click)="logOut()"
        (keydown.space)="logOut()"
        (keydown.enter)="logOut()"
        tabindex="0"
      >
        {{ 'menu.logout' | translate }}
      </div>
      <div class="contacts-footer">
        <div class="row mt-4">
          <div class="col-5 offset-sm-1 my-auto">
            <svg-icon src="assets/logo/moneco-logo-big.svg" [svgStyle]="{ 'width.px':116 }"></svg-icon>
          </div>
          <div class="col-7 col-sm-6">
            <ul class="footer-list">
              <li>
                <svg-icon src="assets/icons/phone.svg" [svgStyle]="{ 'width.px': 19 }"></svg-icon>
                <a class="contacts-label" href="tel:{{ 'footer.phoneNumber' | translate }}">
                  {{ 'footer.phoneNumber' | translate }}
                </a>
              </li>
              <li>
                <svg-icon src="assets/icons/envelope.svg" [svgStyle]="{ 'width.px': 19 }"></svg-icon>
                <a class="contacts-label" href="mailto:{{ 'footer.email' | translate }}">
                  {{ 'footer.email' | translate }}
                </a>
              </li>
              <li>
                <svg-icon src="assets/icons/cursor.svg" [svgStyle]="{ 'width.px': 19 }"></svg-icon>
                <a class="contacts-label" href="https://www.{{ 'profile.web' | translate }}">
                  {{ 'profile.web' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  }
</div>

@if (displayBackArrow) {
  <div
    class="app-arrow-back-container"
    (click)="redirectBack()"
    [ngStyle]="{ 'margin-top.px': nativeSafeZoneService.paddings.top }"
    [ngClass]="{ 'app-arrow-back-container--offset': offsetBackArrow }"
    (keydown.space)="redirectBack()"
    (keydown.enter)="redirectBack()"
    tabindex="0"
  >
    <svg-icon src="assets/icons/arrow-down.svg" [svgStyle]="{ 'height.px':16 }"></svg-icon>
  </div>
}
